import { connect } from 'react-redux';
import View from './FinancialPlanGoalDropdownView';
import {
  goalId as selectGoalId,
  selectedGoalName,
  goalsList,
} from './FinancialPlanGoalDropdownSelector';
import { setGoalId, setSubGoalType } from './FinancialPlanGoalDropdownActions';
import { selectDisplayAssetBucketing } from '../FinancialPlan/FinancialPlanSelector';
import { selectAssetBucketingHeadline } from '../CommonSelectors/CommonAreaSelector';

const mapStateToProps = (state, ownProps) => ({
  goalId: selectGoalId(state, ownProps),
  selectedGoalName: selectedGoalName(state, ownProps),
  goals: goalsList(state, ownProps),
  displayAssetBucketing: selectDisplayAssetBucketing(state),
  assetBucketingHeadline: selectAssetBucketingHeadline(state),
});

const mapDispatchToProps = dispatch => ({
  setGoalId: (goalId, clientId, onGoalChanged, goalType) => {
    dispatch(setGoalId(goalId, clientId));
    if (typeof onGoalChanged === 'function') {
      setTimeout(() => onGoalChanged(goalId, clientId, goalType), 0);
    }
  },

  setSubGoalType: (subGoalTypeId, clientId) => {
    dispatch(setSubGoalType(subGoalTypeId, clientId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
